// extracted by mini-css-extract-plugin
export default {"container":"Wrapper_container__PDMR0","content":"Wrapper_content__mm6g2"};